import { createFileRoute } from "@tanstack/react-router"
import Download from "@/app/settings/resources/download/page"

export const Route = createFileRoute("/settings/resources/download")({
  component: Download,
})
